module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/elon-university-234c6c1cd2e6a01e496befd73cc3dc12.jpg";